import React, { useEffect, useState } from "react";
import { OwIconButton } from "../OwIconButton/OwIconButton";
import OwLabel from "../OwLabel/OwLabel";
import { ControlBar } from "../ControlBar/ControlBar";

type Props = {
    totalItems: number;
    totalProcessed: number;
    totalErrors?: number;
    errorDetails?: any[];
    showClose?: boolean;
    closeFn?: () => void;
};

const SyncStatus = (props: Props) => {
    const [lineWidth, setLineWidth] = useState(0);

    useEffect(() => {
        const calculatedLineWidth = (props.totalProcessed / props.totalItems) * 100;
        setLineWidth(calculatedLineWidth);
    }, [props.totalProcessed, props.totalItems]);

    const download = (filename: string, text: string) => {
        const element = document.createElement("a");
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
        element.setAttribute("download", filename);

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };

    const downloadErrorDetails = () => {
        if (props.errorDetails) {
            const details = JSON.stringify(props.errorDetails);
            download(`Error Details.txt`, details);
        }
    };

    const mainElement = (
        <div>
            <div className={"d-flex align-items-baseline"}>
                {props.showClose && props.closeFn ? (
                    <OwIconButton iconClass={"fas fa-times"} iconColorClass={"text-danger"} fn={props.closeFn} title={"close"} />
                ) : null}
                <OwLabel title={"processing"} noBottomMargin={true} postText={":"} className={"me-3 ms-1"} />
                {props.totalProcessed}
                <OwLabel title={"of"} noBottomMargin={true} className={"ms-1 me-1"} />
                {props.totalItems}
            </div>
            <div className={"bg-warning"} style={{ height: "3px", width: `${lineWidth}%` }}></div>
            {props.totalErrors && props.totalErrors > 0 ? (
                <div className={"mt-3"}>
                    <OwLabel title={"errors"} postText={":"} className={"mb-3"} />
                    {props.totalErrors}
                    <OwLabel title={"download_error_details"} fn={downloadErrorDetails} />
                </div>
            ) : null}
        </div>
    );

    return (
        <div className="SyncStatus">
            <ControlBar
                sections={[
                    {
                        elements: [mainElement],
                        name: "main",
                    },
                ]}
            />
        </div>
    );
};

export default SyncStatus;
